export const REQUEST_BOARD_CARD_NUMBER_PREFIX = '#'
